import * as React from 'react';
import { useFilterSearchParams } from 'pages/Shipments/Containers/utilities';
import { RadioGroup, RadioOption } from 'components/tailwind-ui/RadioGroup';
import { Section } from './Section';

const OPTIONS: RadioOption[] = [
  { label: 'Is known', value: 'true' },
  { label: 'Is unknown', value: 'false' },
];

export const PerDiem: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const hasFees = React.useMemo(() => {
    const { hasPerDiemFees } = searchParams;
    if (hasPerDiemFees === null) {
      return null;
    }

    return hasPerDiemFees ? 'true' : 'false';
  }, [searchParams]);

  const clearFilters = () => {
    setSearchParams({
      hasPerDiemFees: null,
    });
  };

  const onChange = (value: string) => {
    setSearchParams({
      hasPerDiemFees: value === 'true',
    });
  };

  return (
    <Section title="Per diem filters">
      <RadioGroup
        options={OPTIONS}
        filterState={hasFees}
        onChange={onChange}
        onClear={clearFilters}
      />
    </Section>
  );
};
PerDiem.displayName = 'Filters.More.PerDiem';
